export const PRIORITIES = {
  TERM: "term",
  ROP_TERM: "rop_term",
  PERMANENT: "permanent",
  SUPPLEMENT_RETIREMENT: "supplement_retirement",
  GROWTH: "growth",
  INCOME_RIDER: "income_rider",
  BURIAL_EXPENSES: "burial_expenses",
  LTC: "ltc",
  ACCIDENTAL_DEATH: "accidental_death",
  GUARANTEED_ISSUE: "guaranteed_issue",
};

export type LifeInsurancePriority =
  (typeof PRIORITIES)[keyof typeof PRIORITIES];
